import {gql} from '@apollo/client';
import {FEE_PROFILE_FRAGMENT} from '../../graphql/feeProfileFragment';

export const BUILDER_POT = gql`
  ${FEE_PROFILE_FRAGMENT}
  fragment BuilderPotDetails on PotType {
    id
    curoId
    name
    isDeleted
    full
    isCash
    productIsBank
    bankDetails
    currentDirectValue
    valuationMethod
    proposalReference
    feeProfiles {
      ...FeeProfileFragment
    }
    productName {
      id
      formattedName
      acronym
      reportName
    }
    isValidated
    policyHolder
    originalOvrId
    isDataGather
    isAuthorityHeld
    productProvider {
      id
      curoId
      name
      providerType
      isFavourite
      isPanel
      formattedName
      isBank
      reportName
      isSaltus
      showMandateSelector
    }
    totalValue
    isSaltus
    review {
      id
      isSpp
      isSppDa
      isSppAr
      isSppRi
    }
    usedValue
    parent {
      id
    }
    planNumber
    planStatus
    withdrawalReason
    sortCode
    isAuthorised
    nominatedAccount {
      id
      name
    }
    contact {
      id
      simplifiedName
    }
    isDummy
    modelPortfolio {
      id
      name
      providerContact {
        id
        name
        lastName
        jobTitle
      }
    }
    servicingRights
    inSpecie
    isShellPlan
    mandate
    inTrust
    crystallisedFunds
    uncrystallisedFunds
    notes
  }
  fragment BuilderPot on PotType {
    ...BuilderPotDetails
    dentistChildren {
      ...BuilderPotDetails
    }
  }
`;
